import jss from 'jss';

const styles = {
  titleContainer: {
    marginBottom: 5,
    borderBottom: '1px solid rgba(240, 240, 240)'
  },
  title: {
    padding: 0,
    margin: '5px 0'
  },
  requiredIndicator: {
    fontSize: '.83em',
    verticalAlign: 'super',
    color: 'red'
  }
};

export const { classes } = jss.createStyleSheet(styles).attach();


// WEBPACK FOOTER //
// ./src/views/customer/styles/modify-legal.js